module.exports = __webpack_public_path__ + "static/media/ropa-polska.15f6a376.png";